export function removeSpecialCharacters(text: string) {
  text = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  // eslint-disable-next-line no-useless-escape
  text = text.replace(/[;\/?%&*$#!|]/g, "");

  text = text.replace(/[^a-zA-Z0-9 ]/g, "");

  return text;
}
